import NGTDialogPlayer from "../../../ngt/dialog/NGTDialogPlayer";
import KeyDecisionContentEvent from "../../key-decisions/event/KeyDecisionContentEvent";
import AppDefaultDialogPlayer from "../framework/player/AppDefaultDialogPlayer";

export default class AppNGTDialogPlayer extends NGTDialogPlayer {
    constructor(variableManager, playSessionModel, languagePack, config, dispatcher, dialogFactory) {
        console.log("AppNGTDialogPlayer.constructor");
        super(variableManager, playSessionModel, languagePack, config, dispatcher, dialogFactory);
    }

    createDialogPlayer() {
        this._dialogPlayer = new AppDefaultDialogPlayer(100);
    }

    addEventListeners() {
        super.addEventListeners();
        this._dialogPlayer.addEventListener(KeyDecisionContentEvent.KEY_DECISION_CONTENT_IGNORED, this._handleKeyDecisionContentIgnored, this);
    }

    removeEventListeners() {
        super.removeEventListeners();
        this._dialogPlayer.removeEventListener(KeyDecisionContentEvent.KEY_DECISION_CONTENT_IGNORED, this._handleKeyDecisionContentIgnored, this);
    }

    _handleKeyDecisionContentIgnored(event) {
        this.eventDispatcher.dispatch(KeyDecisionContentEvent.KEY_DECISION_CONTENT_IGNORED, event.data);
    }
}